import { connect } from 'react-redux';

import {
  actionCleanupDiscoverProvinceDetails,
  actionCleanupDiscoveryProvinces,
  actionGetDiscoveryProvinceDetails,
  actionGetDiscoveryProvinces,
} from 'store/discover-province/actions';
import ManagerDiscoveryProvinces from './ManagerDiscoveryProvinces';

const mapStateToProps = (state) => ({
  provincesLoading: state.DiscoverProvince.provincesLoading,
  provinces: state.DiscoverProvince.provinces,

  provinceDetailsLoading: state.DiscoverProvince.provinceDetailsLoading,
  provinceDetails: state.DiscoverProvince.provinceDetails,
});

const mapDispatchToProps = ({
  actionGetDiscoveryProvinces,
  actionCleanupDiscoveryProvinces,
  actionGetDiscoveryProvinceDetails,
  actionCleanupDiscoverProvinceDetails,
});

export default connect(mapStateToProps, mapDispatchToProps)(ManagerDiscoveryProvinces);
